module.exports = __webpack_public_path__ + "static/media/avatarReview.cff29371.svg";